/** @internal */
export const _unsubscribe: unique symbol = Symbol('unsubscribe');

/** @internal */
export const _complete: unique symbol = Symbol('complete');

/** @internal */
export const _lazySubj: unique symbol = Symbol('lazySubj');

/** @internal */
export const _destroyed: unique symbol = Symbol('destroyed');

/** @internal */
export const _init: unique symbol = Symbol('init');

/** @internal */
export const _setProp: unique symbol = Symbol('setProp');

/** @internal */
export const _subscrTo: unique symbol = Symbol('subscrTo');

/** @internal */
export const _subscrToSubs: unique symbol = Symbol('subscrToSubs');

/** @internal */
export const _hookMgr: unique symbol = Symbol('hookMgr');
